import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeDeleteGeneralAttestationMutation as useDeDeleteGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeDeleteGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeDeleteGeneralAttestationMutation($input: De_deleteGeneralAttestationInput!) {
    de_deleteGeneralAttestation(input: $input) {
      de_GeneralAttestation {
        id @deleteRecord
      }
    }
  }
`

const useDeDeleteGeneralAttestationMutation = () => {
  const [commit, isFlight] = useMutation<useDeDeleteGeneralAttestationMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteGeneralAttestationMutation }
